import React, { forwardRef } from 'react';
import { Pane } from '../Pane';
import { getPagePromptHeaderId, PromptHeader } from '../PromptHeader';
import { AutoInteractionBar } from '../AutoInteractionBar';
import { Media } from '../Media';
import { SectionState } from '../../store/section/SectionState';
import { exposeTestId } from '../../config';
import { connect } from 'react-redux';
import { MaximizedLayout } from '../MaximizedLayout';
import { useCustomReportAreaOverlay } from '../CustomOverlay';
import { selectLayoutState, selectPromptHeaderFlexDirection } from '../../store/selectors';
import { ReportSectionZeroState } from '../ReportSectionZeroState';
import { bindActionCreators } from 'redux';
const ReportSectionBase = forwardRef(function (props, ref) {
    let isActiveSection;
    {
        let activeSection;
        const { hiddenSection, currentSection } = props.sectionState;
        if (hiddenSection) {
            activeSection = hiddenSection;
        }
        else {
            activeSection = currentSection ? props.sectionState.byId[currentSection] : undefined;
        }
        isActiveSection = (activeSection === null || activeSection === void 0 ? void 0 : activeSection.id) === props.data.id;
    }
    const CustomReportAreaOverlay = useCustomReportAreaOverlay();
    const renderMedia = () => {
        if (!props.hasContent) {
            return (React.createElement(ReportSectionZeroState, { hideAutoChartButton: true, emptyViewEditable: props.sectionState.emptyViewEditable, onPressCreateAutoChart: () => {
                    props.actions.notifyPressCreateAutoChart(props.data.id);
                }, onPressSelectTemplate: () => {
                    props.actions.notifyPressSelectTemplate(props.data.id);
                } }));
        }
        else {
            return React.createElement(Media, { id: props.data.rootContainerId });
        }
    };
    // Determines whether the padding is too small to display prompt header control arrows
    const smallPadding = parseInt(props.data.padding || '') < 16;
    if (!props.data.rootContainerId)
        return null;
    return (React.createElement(Pane, { style: Object.assign({ display: 'flex', flexGrow: 1, flexBasis: 0, overflow: 'hidden', flexDirection: props.headerFlexDirection, padding: props.data.padding, backgroundColor: props.reportBackgroundColor }, props.style), ref: ref, onContextMenu: props.onContextMenu, "data-testid": exposeTestId() ? props.data.id : undefined },
        React.createElement(PromptHeader, { id: getPagePromptHeaderId(props.data.rootContainerId), type: "page", viewMode: !props.sectionState.emptyViewEditable, pageTabRedesign: props.sectionState.pageTabRedesign, hiddenNavigation: props.hideNavigation, reportPromptHeaderHasHover: props.promptHeaderHover, hideArrow: smallPadding }),
        React.createElement("div", { "data-testid": exposeTestId() ? props.data.rootContainerId : undefined, style: {
                position: 'relative',
                display: 'flex',
                flexBasis: 0,
                flexGrow: 1,
                flexDirection: 'column',
            } },
            React.createElement(AutoInteractionBar, { id: props.data.rootContainerId }),
            isActiveSection && props.maximizedVisual ? (React.createElement(MaximizedLayout, { id: props.maximizedVisual })) : (renderMedia()),
            CustomReportAreaOverlay && (React.createElement(CustomReportAreaOverlay, { id: props.data.rootContainerId, type: "section" })))));
});
export const ReportSection = connect((state, props) => {
    var _a, _b, _c;
    return {
        maximizedVisual: state.bird.maximizedVisual,
        sectionState: state.sections,
        reportBackgroundColor: (_a = state.bird.reportBackgroundColor) !== null && _a !== void 0 ? _a : undefined,
        hasContent: !!((_c = selectLayoutState(state, (_b = props.data.rootContainerId) !== null && _b !== void 0 ? _b : '').childKeys) === null || _c === void 0 ? void 0 : _c.length),
        headerFlexDirection: selectPromptHeaderFlexDirection(state, getPagePromptHeaderId(props.data.rootContainerId || '')),
    };
}, (dispatch) => ({
    actions: bindActionCreators(SectionState.actions, dispatch),
}), undefined, { forwardRef: true })(ReportSectionBase);
